import React from 'react';
import BetsContainer from '../common/BetsContainer';
import ScrollingBetsContainer from '../common/ScrollingBetsContainer';
import { useShowOnlyFirstBet, useUserSettings } from '../common/UserSettingsProvider';
import { parseIntFromString } from '../data/utils/parseIntFromString';

export default function EventBets(props) {
    const userSettings = useUserSettings();
    const singleBetMode = useShowOnlyFirstBet();
    let bets = props.bets;

    if (singleBetMode) {
        if (props.betId == null) {
            if (bets.length > 0) {
                bets = [bets[0]];
            } else {
                bets = [];
            }
        } else {
            const bet = bets.find(b => `${b.id}_${b.handicap}` === props.betId);
            if (bet == null) {
                const betId = parseIntFromString(props.betId.split('_')[0]);
                bets = bets.filter(bet => bet.id === betId);
            } else {
                bets = [bet];
            }

            if (bets.length > 0) {
                const firstBet = bets[0];
                if (bets[0].tipoHandicap === 6) {
                    bets.forEach(bet => {
                        if (bet.tipoHandicap === 6 && bet.id === firstBet.id && bet.handicap !== firstBet.handicap) {
                            bets.push(bet);
                        }
                    });
                }
            }
        }
    }

    return (
        <div className="xs_scrollingBetsContainer py-1">
            {userSettings.scrollingBets ?
                <>
                    <div className="w-full overflow-x-auto flex">
                        <ScrollingBetsContainer bets={bets} />
                    </div>
                    {/* <div className="absolute w-[30px] top-0 right-0 bottom-0 linear-gradient"></div> */}
                </>
                :
                <div className="flex flex-col">
                    <BetsContainer bets={bets} betsById={props.betsById} isLive={props.isLive} />
                </div>
            }
        </div>
    );
}
